const VERSION = "0.9.7";

export default VERSION;
